import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "Rhythm Check Training";
const SITE_URL = "https://medical-training-hub-5.preview.emergentagent.com";
const DEFAULT_DESC =
  "AHA-aligned BLS, ACLS, PALS, Heartsaver CPR/First Aid, and workplace safety training across the DFW area for healthcare professionals, medical practices, and businesses.";
const DEFAULT_IMG =
  "https://customer-assets.emergentagent.com/job_medical-training-hub-5/artifacts/4k3ssku3_RhythmCheckLogo.jpg";

export default function Seo({
  title,
  description = DEFAULT_DESC,
  path = "",
  image = DEFAULT_IMG,
  type = "website",
  jsonLd,
}) {
  const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — DFW CPR, BLS, ACLS, PALS & Safety Classes`;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}

export const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: SITE_NAME,
  description: DEFAULT_DESC,
  image: DEFAULT_IMG,
  url: SITE_URL,
  telephone: "+1-214-797-5539",
  areaServed: "Dallas–Fort Worth, TX",
  address: {
    "@type": "PostalAddress",
    addressRegion: "TX",
    addressCountry: "US",
    addressLocality: "Dallas–Fort Worth Area",
  },
  priceRange: "$$",
};

export function courseJsonLd(c) {
  return {
    "@context": "https://schema.org",
    "@type": "Course",
    name: c.name,
    description: c.tagline,
    provider: { "@type": "Organization", name: SITE_NAME, sameAs: SITE_URL },
  };
}
